module.exports = __webpack_public_path__ + "static/front-f0be1973b4ff5c5400a6603143ad518e.jpg";